<template>
  <div class="netMark" v-if="type === 1" >
    <span><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备14017251号-5</a></span>
    <a href="#">监督举报</a>
  </div>
  <div class="netMark" v-else >
    <span><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024059360号-1</a></span>
    <i class="icp-icon"></i>
    <span><a href="#">京公网备案 11010202009747号</a></span>
    <a href="#">监督举报</a>
  </div>
</template>

<script>
export default {
  name: 'webIcp',
  data() {
    return {
      type: 1
    }
  },
  created() {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
      this.type = 1;
    }else {
      this.type = 2;
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.netMark {
  display: flex;
  margin-top: 16px;
  align-items: center;

  .icp-icon {
    display: inline-block;
    width: 16px;
    height: 18px;
    background: url(@/assets/images/img/jinghui.png) no-repeat center/100%;
    margin-right: 8px;
  }

  span {
    font-size: 14px;
    margin-right: 24px;
  }

  & > a {
    font-size: 14px;
    border: 1px solid #86909c;
    border-radius: 4px;
    padding: 0 8px;
    color: #86909c;
  }
}
</style>
